import request from '@/libs/http/index'

export const chargePrintAutoSettingList = () =>
  request.get({ url: '/clinic/charge-print-auto-setting/list' })

export const chargePrintAutoSettingSave = (data: any) =>
  request.put({ url: '/clinic/charge-print-auto-setting/save', data })

export const pharmacyPrintAutoSettingList = () =>
  request.get({ url: '/clinic/pharmacy-print-auto-setting/list' })

export const pharmacyPrintAutoSettingSave = (data: any) =>
  request.put({ url: '/clinic/pharmacy-print-auto-setting/save', data })
